import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-stat-slider .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const slides = slider.querySelectorAll('.swiper-slide');
		const block = slider.closest('.block-stat-slider');

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 10,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: block.querySelector('.swiper-button-prev'),
				nextEl: block.querySelector('.swiper-button-next'),
			},
		};

		new Swiper(slider, settings);
	});
}
